import React, { Component } from 'react';
import PropTypes from "prop-types";

class Footer extends Component {  
  render() {
    let {siteConfig} = this.props;
    
    return (
      <footer className="app-footer">
        {siteConfig.companyName} &copy; 2021 Spinn Pty Ltd.
      </footer>
    );
  }
}
Footer.propTypes = {  
  siteConfig: PropTypes.object.isRequired,
};

export default Footer;
